const TestiProps = [
    {
        id: "1",
        imgSrc: "imgs/avatar2.jpg",
        title: "Emily Reb",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eaque doloribus autem aperiam earum nostrum omnis blanditiis corporis perspiciatis adipisci nihil.",
    },
    {
        id: "3",
        imgSrc: "imgs/avatar3.jpg",
        title: "Emily Reb",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eaque doloribus autem aperiam earum nostrum omnis blanditiis corporis perspiciatis adipisci nihil.",
    },
]

export default TestiProps;